<template>
  <div class="w-full h-full">
    <div class="max-w-7xl mx-auto h-screen flex justify-center items-center">
      <div class="flex flex-col gap-4">
        <h2 class="text-center text-xl lg:text-5xl text-black font-bold">
          Thank You
        </h2>
        <p class="text-black text-lg">Payment sucessfully</p>
        <div>
          <table>
            <thead>
              <tr>
                <th class="border  border-gray-400 p-2 w-[150px]">Payment id</th>
                <th class="border  border-gray-400 p-2 w-[150px]">Order id</th>
                <th class="border  border-gray-400 p-2 w-[150px]">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="border  border-gray-400 p-2 w-[150px]">test</td>
                <td class="border  border-gray-400 p-2 w-[150px]">test</td>
                <td class="border  border-gray-400 p-2 w-[150px]">test</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankyouPage",
};
</script>

<style></style>
